const onRowDelete = async (oldData) => {
  console.log('vatdeduct onRowDelete')
}

export default onRowDelete
